import { createReducer, on } from '@ngrx/store';
import { MonitorSegment } from 'src/app/models/monitor-segments.model';
import { MonitorValueType } from 'src/app/models/monitor-value-type.model';

import MonitorActions from './actions';
import { MonitorState } from './feature';

export const initialMonitorState = (): MonitorState => ({
  defaultMonitorSegment: MonitorSegment.Grass,
  activeMonitorSegment: undefined,
  [MonitorSegment.Mow]: {
    targetValues: {
      [MonitorValueType.DSGram]: { min: undefined, max: undefined },
      [MonitorValueType.Protein]: { min: 150, max: 200 },
      [MonitorValueType.Sugar]: { min: 100, max: 175 },
      [MonitorValueType.VEM]: { min: 900, max: 975 },
      [MonitorValueType.DSPercent]: { min: undefined, max: undefined },
      [MonitorValueType.Height]: { min: undefined, max: undefined },
    },
  },
  [MonitorSegment.Grass]: {
    targetValues: {
      [MonitorValueType.DSGram]: { min: undefined, max: undefined },
      [MonitorValueType.Protein]: { min: 150, max: 200 },
      [MonitorValueType.Sugar]: { min: 100, max: 150 },
      [MonitorValueType.VEM]: { min: 950, max: 1050 },
      [MonitorValueType.DSPercent]: { min: undefined, max: undefined },
      [MonitorValueType.Height]: { min: undefined, max: undefined },
    },
  },
  [MonitorSegment.GrassOrganic]: {
    targetValues: {
      [MonitorValueType.DSGram]: { min: undefined, max: undefined },
      [MonitorValueType.Protein]: { min: 150, max: 200 },
      [MonitorValueType.Sugar]: { min: 100, max: 150 },
      [MonitorValueType.VEM]: { min: 925, max: 1025 },
      [MonitorValueType.DSPercent]: { min: undefined, max: undefined },
      [MonitorValueType.Height]: { min: undefined, max: undefined },
    },
  },
  [MonitorSegment.Maize]: {
    targetValues: {
      [MonitorValueType.DSGram]: { min: undefined, max: undefined },
      [MonitorValueType.Protein]: { min: 150, max: 200 },
      [MonitorValueType.Sugar]: { min: 100, max: 150 },
      [MonitorValueType.VEM]: { min: 925, max: 1025 },
      [MonitorValueType.DSPercent]: { min: 35, max: 38 },
      [MonitorValueType.Height]: { min: undefined, max: undefined },
    },
  },
});

const MonitorReducer = createReducer(
  initialMonitorState(),
  on(MonitorActions.setActiveMonitorSegment, (state, { segment }) => ({
    ...state,
    activeMonitorSegment: segment,
  })),
  on(MonitorActions.setMonitorSegmentAdvice, (state, { segment, advice }) => ({
    ...state,
    [segment]: {
      ...state[segment],
      advice: advice,
    },
  })),
  on(
    MonitorActions.setMonitorSegmentPeriods,
    (state, { segment, periods }) => ({
      ...state,
      [segment]: {
        ...state[segment],
        currentPeriod: periods.currentPeriod,
        previousPeriod: periods.previousPeriod,
      },
    }),
  ),
  on(
    MonitorActions.setMonitorSegmentScoreAndTrend,
    (state, { segment, score, trend }) => ({
      ...state,
      [segment]: {
        ...state[segment],
        score,
        trend,
      },
    }),
  ),
);

export default MonitorReducer;
